const LIVE_PREFIX = 'https://datadesk-prod-origin.californiatimes.com';
const TEST_PREFIX = 'https://elections-2022-backend-dev.s3.amazonaws.com';

///////STATE

export const GEOGRAPHY_URL =
  'https://bigbuilder.s3.us-west-1.amazonaws.com/projects/elections-data/2020-11-03/geographies/states/ca.json';

export const STATE_URL =
  'https://bigbuilder.s3.us-west-1.amazonaws.com/projects/elections-data/2022-11-08/latest-state.json';
// 'https://elections-2022-backend-dev.s3.amazonaws.com/projects/elections-data/2022-11-08/latest-state.json';

/////////NATIONAL
export const US_GEOGRAPHYURL =
  'https://bigbuilder.s3.us-west-1.amazonaws.com/projects/elections-data/2022-11-08/geographies/us.json';

export const TRENDS_URL =
  'https://bigbuilder.s3.us-west-1.amazonaws.com/projects/elections-data/2022-11-08/latest-reports.json';

//'https://elections-2022-backend-dev.s3.amazonaws.com/projects/elections-data/2022-11-08/latest-reports.json';

export const USHOUSE_URL =
  'https://bigbuilder.s3.us-west-1.amazonaws.com/projects/elections-data/2022-11-08/latest-house.json';

//'https://elections-2022-backend-dev.s3.amazonaws.com/projects/elections-data/2022-11-08/latest-house.json';

export const USSENATE_URL =
  'https://bigbuilder.s3.us-west-1.amazonaws.com/projects/elections-data/2022-11-08/latest-senate.json';

// 'https://elections-2022-backend-dev.s3.amazonaws.com/projects/elections-data/2022-11-08/latest-senate.json';

export const USGOV_URL =
  'https://bigbuilder.s3.us-west-1.amazonaws.com/projects/elections-data/2022-11-08/latest-gov.json';

// 'https://elections-2022-backend-dev.s3.amazonaws.com/projects/elections-data/2022-11-08/latest-gov.json';

////////////////Local county urls

export const LOS_ANGELES_URL =
  'https://bigbuilder.s3.us-west-1.amazonaws.com/projects/elections-data/2022-11-08/la.json';
//'https://elections-2022-backend-dev.s3.amazonaws.com/projects/elections-data/2022-11-08/la.json';

export const SAN_DIEGO_URL =
  'https://bigbuilder.s3.us-west-1.amazonaws.com/projects/elections-data/2022-11-08/sd.json';
//'https://elections-2022-backend-dev.s3.amazonaws.com/projects/elections-data/2022-11-08/sd.json';

export const ORANGE_URL =
  'https://bigbuilder.s3.us-west-1.amazonaws.com/projects/elections-data/2022-11-08/oc.json';
// 'https://elections-2022-backend-dev.s3.amazonaws.com/projects/elections-data/2022-11-08/oc.json';

export const EMBED_URL =
  'https://bigbuilder.s3.us-west-1.amazonaws.com/projects/elections-data/2022-11-08/embeds.json';
//'https://elections-2022-backend-dev.s3.amazonaws.com/projects/elections-data/2022-11-08/embeds.json';

// export const STATE_URL = `${
//   process.env.NODE_ENV === 'production' ? LIVE_PREFIX : TEST_PREFIX
// }/projects/elections-data/2022-11-08/latest-state.json`;

// export const USSENATE_URL = `${
//   process.env.NODE_ENV === 'production' ? LIVE_PREFIX : TEST_PREFIX
// }/projects/elections-data/2022-11-08/latest-senate.json`;

// export const USHOUSE_URL = `${
//   process.env.NODE_ENV === 'production' ? LIVE_PREFIX : TEST_PREFIX
// }/projects/elections-data/2022-11-08/latest-house.json`;

// export const USGOV_URL = `${
//   process.env.NODE_ENV === 'production' ? LIVE_PREFIX : TEST_PREFIX
// }/projects/elections-data/2022-11-08/latest-gov.json`;
